import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { EMPTY, throwError, of } from 'rxjs';
import { map, catchError, exhaustMap, switchMap } from 'rxjs/operators';
import { ParameterService } from '@parameter/parameter.service';
import * as parameterActions from '@parameter/store/parameter.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { Parameter } from '@models';
import { errorTypes } from '@parameter/store/parameter.reducer';

@Injectable()
export class ParameterEffects {
  loadParameters$ = createEffect(() => this.actions$.pipe(
    ofType(parameterActions.getCollection),
    exhaustMap(() => this.parameterService.getParameters().pipe(
        map(params => parameterActions.collectionLoaded({newCollection: params})),
        catchError(() => EMPTY)
    ))
  ));

  constructor(
    private actions$: Actions,
    private parameterService: ParameterService,
  ) { }
}
